<template>
  <ui-modal
    :show="showScore"
    type="tag"
    :title="title"
    @close="showScore = false"
  >
    <div class="score-box">
      <ui-frame-bg class="gameList-box" colorType="blue-light">
        <ul class="gameList" v-if="matchList && matchList.length != 0">
          <li
            v-for="(item, key) in matchList"
            :key="key"
            :name="item.matchCode"
            :class="{ active: subMatch == item.matchCode }"
            @click="switchGame(item.matchCode, item.name)"
          >
            <ui-frame-bg class="bg-active" colorType="yellow"></ui-frame-bg>
            <div class="label-box">
              <span class="label-shadow">{{ item.name }}</span>
              <span class="label-text">{{ item.name }}</span>
            </div>
          </li>
        </ul>
        <div class="scene" v-if="matchList && matchList.length <= 7"></div>
      </ui-frame-bg>
      <div class="score" name="match" v-show="this.subMatch != 'all'">
        <ul class="header">
          <li name="rank">
            <!-- <div class="bg"></div> -->
            <div class="label-box">
              <span class="label-shadow">排名</span>
              <span class="label-text">排名</span>
            </div>
          </li>
          <li v-for="(item, key) in header" :key="key" :name="item.key">
            <!-- <div class="bg"></div> -->
            <div class="label-box">
              <span class="label-shadow">{{ item.name }}</span>
              <span class="label-text">{{ item.name }}</span>
            </div>
          </li>
        </ul>
        <ul class="data-box">
          <div
            class="list-box"
            v-if="
              subFightScore &&
              subFightScore.teamRankInfos &&
              subFightScore.teamRankInfos.length != 0
            "
          >
            <li
              v-for="(score, key) in subFightScore.teamRankInfos"
              :key="key"
            >
              <ol>
                <li name="rank">
                  <div class="label-box">
                    <span class="label-shadow">{{ key + 1 }}</span>
                    <span class="label-text">{{ key + 1 }}</span>
                  </div>
                </li>
                <li v-for="(item, key) in header" :key="key" :name="item.key">
                  <div v-if="item.key != specialHeader">
                    {{
                      score[item.key] || score[item.key] === 0
                        ? score[item.key]
                        : "-"
                    }}
                  </div>
                  <div class="teamInfo" v-if="item.key == specialHeader">
                    <div
                      class="avatar"
                      :style="{
                        'background-image': `url(${
                          score['avatar'] ? score['avatar'] : ''
                        })`,
                      }"
                    ></div>
                    <div class="name">{{ score["name"] }}</div>
                  </div>
                </li>
              </ol>
            </li>
          </div>
          <Interdict
            v-else-if="!subFightScore ||
              !subFightScore.teamRankInfos ||
              (subFightScore.teamRankInfos && subFightScore.teamRankInfos.length == 0)"
            tip="暂无数据"
            :loading="inRequire"
            loadingTip="正在获取最新成绩..."
            hook="px"
          />
        </ul>
      </div>
      <div class="score" name="integral" :class="{ numHook: headerIntegral.length >= 9 }" v-show="this.subMatch == 'all'">
        <ul class="header">
          <li name="rank">
            <!-- <div class="bg"></div> -->
            <div class="label-box">
              <span class="label-shadow">排名</span>
              <span class="label-text">排名</span>
            </div>
          </li>
          <li v-for="(item, key) in headerIntegral" :key="key" :name="item.key">
            <!-- <div class="bg"></div> -->
            <div class="label-box">
              <span class="label-shadow">{{ item.name }}</span>
              <span class="label-text">{{ item.name }}</span>
            </div>
          </li>
        </ul>
        <ul class="data-box">
          <div
            class="list-box"
            v-if="totalIntegralList && totalIntegralList.length != 0"
          >
            <li v-for="(score, key) in totalIntegralList" :key="key">
              <ol>
                <li name="rank">
                  <i v-if="score.is_promotion"></i>
                  <div class="label-box" v-else>
                    <span class="label-shadow">
                      {{ score["total"] || score["total"] === 0 ? key + 1 : "-" }}
                    </span>
                    <span class="label-text">
                      {{ score["total"] || score["total"] === 0 ? key + 1 : "-" }}
                    </span>
                  </div>
                </li>
                <li
                  v-for="(item, key) in headerIntegral"
                  :key="key"
                  :name="item.key"
                >
                  <div v-if="item.key != specialHeader">
                    {{ score[item.key] ? score[item.key] : "-" }}
                  </div>
                  <div class="teamInfo" v-if="item.key == specialHeader">
                    <div
                      class="avatar"
                      :style="{
                        'background-image': `url(${
                          score['avatar'] ? score['avatar'] : ''
                        })`,
                      }"
                    ></div>
                    <div class="name">{{ score["name"] }}</div>
                  </div>
                </li>
              </ol>
            </li>
          </div>
          <Interdict
            v-else-if="!totalIntegralList || (totalIntegralList && totalIntegralList.length == 0)"
            tip="暂无数据"
            :loading="inRequire"
            loadingTip="正在获取最新成绩..."
            hook="px"
          />
        </ul>
      </div>
    </div>
  </ui-modal>
</template>

<script>
import * as api from "@/service/index";
import { mapState } from "vuex";
import UiModal from "@/components/ui-modal.vue";
import uiFrameBg from "../../components/ui-frame-bg.vue";
import Interdict from '@/components/interdict';

export default {
  components: {
    UiModal,
    uiFrameBg,
    Interdict,
  },
  props: {
    matchID: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      title: "", // 传递过来的积分表标题
      subMatch: "",
      specialHeader: "team",
      header: [
        { key: "team", name: "战队" },
        { key: "singleRankingPoint", name: "排名分" },
        { key: "totalKillScore", name: "淘汰分" },
        { key: "totalPoint", name: "总积分" },
      ],
      headerIntegral: [{ key: "team", name: "战队" }],
      scoreList: [], // 全部对局的成绩
      totalIntegralList: [], // 全部队伍的总积分
      matchList: [], // 右侧对局列表
      showScore: false,
      inRequire: true, // 正在请求数据
    };
  },
  computed: {
    ...mapState(["scale", "seasonInfo", "token"]),
    subFightScore() {
      return this.scoreList.find((item) => item.matchCode == this.subMatch);
    },
  },
  methods: {
    switchGame(code, name) {
      this.subMatch = code;

      // 埋点
      if(typeof tapdb == 'undefined') return;
      tapdb.trackEvent('切换详情局', {
        '#schedule_id': this.title,
        '#match_id': name
      });
    },
    initMatchDetail(code, title) {
      this.inRequire = true;
      this.resetData();
      this.title = title;
      let thisSeasonId = this.seasonInfo.id || '';
      if(!this.token) return;
      let data = {
        scheduleCode: code,
        token: this.token,
        seasonId: thisSeasonId
      };
      api.reqMatchDetail(data).then((response) => {
        if (response.status == 200) {
          let matchInfo = response.data;

          // 所有侧边栏对局
          this.matchList = matchInfo.baseMatchLists;
          // 总积分的头部
          let header_ = this.matchList.map((match) => {
            return { key: match.matchCode, name: match.name };
          });
          this.headerIntegral.push.apply(this.headerIntegral, header_);
          this.headerIntegral.push({ key: "total", name: "总积分" });
          // 添加总积分的侧边栏对局
          if (!this.matchList.find((match) => match.matchCode == "all")) {
            this.matchList.unshift({
              matchCode: "all",
              name: "总积分",
            });
          }
          this.scoreList = matchInfo.matchDetailLists;
          this.totalIntegralList = matchInfo.totalIntegral;

          this.subMatch = "all";
        } else {
          alert(response.data);
        }
        this.inRequire = false;
      });

      this.showScore = true;
    },
    closeModal() {
      this.showScore = false;

      // 关闭弹窗后，清空数据, 保持数据最新
      this.scoreList = [];
    },
    resetData() {
      this.matchList = [];
      this.scoreList = [];
      this.totalIntegralList = [];
      this.headerIntegral = [{ key: "team", name: "战队" }];
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/schedule/scoreList";
</style>